var map = {
	"./busd.svg": 2075,
	"./crypto-pending.png": 2076,
	"./crypto-reject.png": 2077,
	"./crypto-success.png": 2078,
	"./direpay.svg": 2079,
	"./trx.svg": 2080,
	"./usdc.svg": 2081,
	"./usdt.svg": 2082
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 153;